import { workflowsRepo } from '@/constants/providers';
import { AutomationKey } from '@/modules/Automations/queries/keys';
import { BusinessAreasKey } from '@/modules/BusinessAreas/queries/keys';
import { CompanyKeys } from '@/modules/Companies/queries';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { ProcessKey } from '@/modules/Processes/queries';
import { ApiResponse } from '@/shared/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { WorkflowKey } from './keys';

export const useDeleteWorkflow = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<ApiResponse<unknown>, unknown, number>(
    (id) => workflowsRepo.deleteWorkflow(id),
    {
      onError: () => {
        toast.error(t('error_delete_workflow'));
      },
      onSuccess: () => {
        toast.success(t('success_delete_workflow'));
        queryClient.invalidateQueries(AutomationKey.ALL);
        queryClient.invalidateQueries(OrganizationKeys.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(BusinessAreasKey.ALL);
        queryClient.invalidateQueries(ProcessKey.ALL);
        queryClient.invalidateQueries(WorkflowKey.ALL);
      },
    },
  );
};
